export default "__VITE_ASSET__DDoWOX13__"